import React, { useEffect, useState } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

const CategorieSection = () => {
  const [categorieCount, setCategorieCount] = useState([]);

  const fetchData = async () => {
    try {
      const response = await corefetch(`Blog/GetBlogCategorieCounts`);

      if (response) {
        setCategorieCount(response);
      }
    } catch (error) {
      setCategorieCount([]);
      console.error("Error fetching amenities:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!categorieCount || categorieCount.length == 0) {
    return null;
  }

  return (
    <>
      <div className="col col-lg-4 order-lg-1">
        <div className="blog-sidebar" style={{ marginBottom: "10px" }}>
          <div className="widget category-widget">
            <h3>Categories</h3>
            <ul>
              <li>
                <a href="/Blogs/2">
                  Quinceanera <span>{categorieCount.quinceanera || 0}</span>
                </a>
              </li>
              <li>
                <a href="/Blogs/3">
                  Wedding <span>{categorieCount.wedding || 0}</span>
                </a>
              </li>
              <li>
                <a href="/Blogs/4">
                  Corporate <span>{categorieCount.corporate || 0}</span>
                </a>
              </li>
              <li>
                <a href="/Blogs/5">
                  Private Parties{" "}
                  <span>{categorieCount.privateParties || 0}</span>
                </a>
              </li>
              <li>
                <a href="/Blogs/15">
                  Birthday <span>{categorieCount.birthday || 0}</span>
                </a>
              </li>
              <li>
                <a href="/Blogs/16">
                  Baby Shower <span>{categorieCount.babyShower || 0}</span>
                </a>
              </li>
              <li>
                <a href="/Blogs/17">
                  Graduation <span>{categorieCount.graduation || 0}</span>
                </a>
              </li>
              <li>
                <a href="/Blogs/18">
                  Engagement <span>{categorieCount.engagement || 0}</span>
                </a>
              </li>
              <li>
                <a href="/Blogs/19">
                  Others <span>{categorieCount.others || 0}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategorieSection;
